<div class="checklist-vacation">
  <ng-container *ngFor="let vacation of searchCriteria ? (vacations | searchVacations) : vacations; trackBy: trackByFunction">
    <app-vacation [isReadOnly]="isReadOnly" [mod]="mod" [vacationInput]="vacation"></app-vacation>
  </ng-container>
</div>
